import { useMutation } from '@apollo/client';
import { REGISTER_COACH_REQUEST } from '../../apollo/mutations/user';

const useRegisterCoachRequest = () => {
    const [requestSignup, { loading, error }] = useMutation(REGISTER_COACH_REQUEST);
  
    const registerCoach = async ({ email, firstName, lastName, organization, profilePicture }) => {
      await requestSignup({ variables: { email, firstName, lastName, organization, profilePicture } });
    };
  
    return { registerCoach, loading, error };
  };
  
  export default useRegisterCoachRequest;